/**
 * 현재 UI 언어를 백엔드 API 용 로케일("ko"|"ja")로 변환.
 *
 * AI 검토/수정근거 등 LLM 생성 텍스트를 사용자의 UI 표기 언어로 만들기 위해
 * 관련 API 호출에 ``locale`` 쿼리로 전달한다. (M24)
 */

import i18n from "@/i18n";

export function currentApiLocale(): "ko" | "ja" {
  const lang = (i18n.resolvedLanguage ?? i18n.language ?? "ko").toLowerCase();
  return lang.startsWith("ja") ? "ja" : "ko";
}
